<template>
    <div class="product-page">
        <div class="main-container header-section"
            style="display: flex; justify-content: space-between; align-items: flex-end;">
            <div>
                <div class="header-top">
                    <h1 class="brand-title">PRODUCT CENTER</h1>
                </div>
                <div class="filter-bar">
                    <el-checkbox-group v-model="selectedCategories" @change="handleFilterChange">
                        <el-checkbox label="" class="custom-checkbox">ALL</el-checkbox>
                        <el-checkbox :label="value.acId" class="custom-checkbox" v-for="value in typeList"
                            :key="value.acId">{{ value.categoryName }}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <el-input placeholder="Search Name" size="small" prefix-icon="el-icon-search" v-model="formData.fileName"
                clearable  @keyup.enter.native="getList(1)" style="width: 300px;">
            </el-input>
        </div>
        <div class="main-container main_null"  v-show="total == 0">PLEASE CONTINUE BROWSING</div>
        <div class="main-container" style="min-height: 400px;">
            <el-row>
                <el-col :xs="8" :sm="6" :md="4" v-for="value in filterList" :key="value.acId" style="text-align: center;">
                    <div class="product-list">
                        <img :src="require('@/assets/pdf.png')" alt="" style="width: 80px; height: 80px;">
                        <div>{{ value.fileName }}</div>
                        <span @click="downloadFile(value)">DOWNLOAD</span>

                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="pagination-section" v-show="total > 0">
            <el-pagination layout="prev, pager, next, slot" :total="total" :current-page.sync="formData.pageNo"
                prev-text="< Previous" next-text="Next >" @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { archivesCategoryNoPage, archivesList } from "@/api/member";
export default {
    data() {
        return {
            typeList: [],
            selectedCategories: [''],
            filterList: [],
            total: 0,
            formData: {
                pageNo: 1,
                pageSize: 18,
                acId: '',
                fileName: ''
            }
        };
    },
    activated() {
        this.getTypelist();
        this.getList(1);
    },
    methods: {
        getTypelist() {
            archivesCategoryNoPage().then(res => {
                if (res.code == 1) {
                    this.typeList = res.data.dataList
                }
            });
        },
        // 分页切换时触发
        getList(pageNo) {
            this.formData.pageNo = pageNo || this.formData.pageNo;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.8)'
            });
            archivesList(this.formData).then(res => {
                this.filterList = res.data.dataList;
                this.total = res.data.count;
            }).finally(() => {
                setTimeout(() => {
                    loading.close();
                }, 500);
            });
        },
        downloadFile(file) {
            window.open(file.fileUrl, '_blank');
        },
        handleFilterChange(val) {
            if (val && val.length > 1) {
                this.selectedCategories = [val[val.length - 1]];
            } else if (val.length === 0) {
                this.selectedCategories = [''];
            }
            this.formData.acId = val[val.length - 1] + '' || '';
            this.getList(1);
        }
    }
};
</script>

<style scoped>
.custom-tooltip {
    background: rgba(43, 35, 30, .8) !important;
}

.el-input.is-active .el-input__inner,
::v-deep .el-input__inner:focus {
    border-color: #2B231E !important;
}
</style>
<style scoped lang="scss">

.product-page {
    background-color: #FAF9F7;
    min-height: 80vh;
    padding: 0px 20px 40px;
    font-family: $sans-font;
    color: #2B231E;

}

.product-page div {
    font-family: $serif-font;
}

.main-container {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 20px;
}

.header-section {
    padding-top: 40px;
    margin-bottom: 40px;

    .header-top {
        margin-bottom: 20px;

        .brand-title {
            display: inline-block;
            font-family: $serif-font;
            font-size: 32px;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 1px;
            /* 模拟左上角标题样式 */
            border: 1px solid transparent;
            padding: 5px 0;
            margin: 0;
            cursor: default;
        }
    }

    .filter-bar {
        display: flex;
        align-items: center;
        gap: 40px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 1px;

        .filter-item {
            cursor: pointer;
            padding-bottom: 2px;
            border-bottom: 1px solid transparent;

            &.active {
                border-bottom: 1px solid #000;
            }
        }

        .control-dropdown {
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 1px;
            text-transform: uppercase;
            color: #2B231E;
        }
    }
}

.pagination-section {
    text-align: center;
    margin-top: 60px;

    ::v-deep .el-pagination {
        font-family: $serif-font;
        font-weight: normal;

        .btn-prev,
        .btn-next {
            background-color: transparent;
            color: #666;
            height: 32px;

            span {
                font-size: 14px;
            }
        }

        .el-pager li {
            background-color: transparent;
            color: #999;
            font-weight: normal;
            font-size: 14px;
            height: 32px;
            line-height: 32px;

            &.active {
                color: #000;
                font-weight: bold;
            }

            &:hover {
                color: #000;
            }
        }
    }
}

::v-deep .el-checkbox__label {
    font-size: 12px;
    color: #999;
    letter-spacing: 1px;
    text-transform: uppercase;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #2B231E;
    font-weight: bold;
}

::v-deep .el-checkbox__inner {
    border-radius: 0;
    /* 方形勾选框 */
    background-color: transparent;
    border-color: #999;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2B231E;
    border-color: #2B231E;
}

.product-list {
    background-color: #fff;
    margin-bottom: 40px;
    width: 80%;
    padding: 30px 20px;
    box-sizing: border-box;
    text-align: center;
    display: inline-block;
}

.product-list div {
    height: 48px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    word-wrap: break-word;
    margin: 15px 0 40px;
}

.product-list span {
    text-decoration: underline;
    cursor: pointer;
}
.main_null {
    font-size: 18px;
    color: #2B231E;
    font-family: $serif-font;
    text-decoration: underline;
}

</style>
